import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 성능/운영>서비스>운영 탭에서 로그를 조회한다.
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getServiceLogList(params) {
    return axios.post(`${baseUrl}/performance/operation-log/get-service-log-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/service/operation-log.js